export function getConstants() {
    const freeLessonModal = document.querySelector(
        '[data-modal="free-lesson"]'
    );
    let btnSignUp, btnSignUpCancel, lessonContent, lessonTitle, lessonDesc;

    if (freeLessonModal) {
        btnSignUp = freeLessonModal.querySelector('[data-modal="sign-up"]');
        btnSignUpCancel = freeLessonModal.querySelector(
            '[data-modal="sign-up-cancel"]'
        );

        lessonContent = freeLessonModal.querySelector(
            '[data-modal="lesson-content"]'
        );

        if (lessonContent) {
            lessonTitle = lessonContent.querySelector(".message-modal__title");
            lessonDesc = lessonContent.querySelector(".message-modal__text");
        }
    }

    return {
        freeLessonModal,
        btnSignUp,
        btnSignUpCancel,
        lessonContent,
        lessonTitle,
        lessonDesc
    };
}
